import { module } from 'modujs';
import modularLoad from '../vendors/modularLoad';

export default class extends module {
    constructor(m) {
        super(m);
    }

    init() {
        this.load = new modularLoad({
            enterDelay: 600,
            loadingClass: 'is-loading'
        });

        this.load.on('loaded', (transition, oldContainer, newContainer) => {
            this.call('destroy', oldContainer, 'app');
            this.call('update', newContainer, 'app');
            window.scrollTo({ top: 0, left: 0, behavior: 'instant' })
        });

        this.load.on('loading', (transition, oldContainer) => {
            this.call('close', null, 'Menu');
        });
    }
}
